import React, { Component } from "react";
import { connect } from "react-redux";
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { cancelSubscription } from "../../store/actions/auth";
import ButtonContent from '../ButtonContent';
import Button from '@material-ui/core/Button';

class CancelSubscription extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      dataLoaded: false
    };
  }

  componentDidMount () {
      console.log(this.props);
  }

  cancelAccount = () => {
    const { cancelSubscription } = this.props;
    cancelSubscription().then((response) => {
        this.hide();
        this.props.logout().then(() => {
          window.location.href='/'
        });
    });
  }

  hide() {
    this.setState({
        show: false
    }, () => {
        this.props.hideCancelSubscriptionModal();
    });
  }

  render() {

    return (
      <div>
        <Dialog
          open={this.state.show}
          onClose={() => this.hide()}
        >
          <DialogTitle>
            Cancel Account
          </DialogTitle>
          <DialogContent style={{width: 500}}>
                <div className="col-md-12" style={{ padding: 0 }}>
                    If you cancel your account, you will lose all exercises, workouts, and programs stored in your library FOREVER.  You will also NOT be paid on the 5th of the following month for any workouts, programs, or subscriptions that may have been purchased by your customers during this month.  Are you sure that you want to cancel the account?
                </div>
                <div style={{marginTop: 10, float: 'right'}}>
                    <Button
                    color='primary'
                    variant="contained"
                    onClick = {this.cancelAccount}
                    >
                    <ButtonContent
                        text={ "Yes"}
                    />
                    </Button>
                </div>
                <div style={{marginTop: 10, marginRight: 10, float: 'right'}}>
                    <Button
                    variant="contained"
                    onClick={() => this.hide()}
                    >
                    <ButtonContent
                        text={ "No"}
                    />
                    </Button>
                </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        cancelSubscription: () => {
            return dispatch(cancelSubscription());
        }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(CancelSubscription);



// WEBPACK FOOTER //
// ./src/components/settings/CancelSubscription.js